import React, { useEffect } from "react";
import { decode } from "html-entities";
// Helpers
import Imaging from "src/helpers/imaging";
// Partials
const Button = React.lazy(() => import("src/partials/button"));

const Start = ({ apiKey, settings, type }) => {

    if (!apiKey) {
        console.log(`No Service Titan API Key for ${type}`);
        return null;
    }

    useEffect(() => {
        const existingScript = document.getElementById("se-widget-embed");

        // If the script already exists with the same API key, do nothing
        if (existingScript && existingScript.getAttribute("data-api-key") === apiKey) {
            if(settings?.autoopen == 1){
                window.setTimeout(() => {
                    handleButtonClick(); 
                }, 2000);
            }
            return;
        }
        // Remove existing script and iframe if API key has changed
        if (existingScript) {
            existingScript.remove();
        }
        const existingIframe = document.getElementById("se-widget-iframe-container");
        if (existingIframe) {
            existingIframe.remove();
        }
        // Add the new script
        const script = document.createElement("script");
        script.id = "se-widget-embed";
        script.src = "https://embed.scheduleengine.net/schedule-engine-v3.js";
        script.setAttribute("data-api-key", apiKey);
        script.setAttribute("data-defer", "true");
        script.async = true;
        script.onload = () => {
            console.log("ScheduleEngine script loaded successfully.");
            if(settings?.autoopen == 1){
                window.setTimeout(() => {
                    handleButtonClick(); 
                }, 2000);
            }
        };

        script.onerror = () => {
            console.error("Failed to load ScheduleEngine script.");
        };

        document.head.appendChild(script);

        // Cleanup when the component unmounts or API key changes
        return () => {
            const cleanupScript = document.getElementById("se-widget-embed");
            if (cleanupScript) {
                cleanupScript.remove();
            }

            const cleanupIframe = document.getElementById("se-widget-iframe-container");
            if (cleanupIframe) {
                cleanupIframe.remove();
            }
        };
    }, [apiKey]);

    const handleButtonClick = () => {
        if (window.ScheduleEngine) {
            window.ScheduleEngine.show();
        } else {
            console.error("ScheduleEngine is not available. Ensure the script has loaded.");
        }
    };
    
    switch (type) {
        case "bottom-mobile-bar":
            return (
                <a className="se-widget-button" onClick={handleButtonClick}>
                    {settings?.button_icon && <Imaging data={settings?.button_icon} />}
                    {decode(settings?.link_text)}
                </a>
            );
        case "quick-links":
            return (
                <a className="se-widget-button" onClick={handleButtonClick}>
                    {decode(settings?.link_text)}
                </a>
            );
        case "main-navigation":
        default:
            return (
                <Button
                    className="se-widget-button"
                    title={settings?.link_text}
                    buttonFunction="styled"
                    frontIcon={settings?.button_icon ? settings?.button_icon : null}
                    type={settings?.button_style}
                    tone={settings?.background_value}
                    onClick={handleButtonClick}
                />
            );
    }

};

export default Start;